module.exports = "/_next/static/images/CreateSingleViewOfTheCustomer-98de9f46c7876b6e00e65b319aa53cc1.webp";